<template>
	<div id="app">
		<router-view />
		<div id="timing" v-if="current != 'home'">
			Il reste {{$store.state.mainTimer}} secondes avant l'abandon de la simulation.
			<router-link to="/">Abandonner maintenant</router-link>
		</div>
	</div>
</template>

<script>
	import { Plugins } from "@capacitor/core";
	const { Keyboard } = Plugins;
	export default {
		name: "Cadre",
		components: {},
		data() {
			return {
				compteur: null,
				current: ""
			};
		},
		updated() {
			this.current = this.$router.history.current.name;
		},
		methods: {
			addTime() {
				this.compteur = setInterval(() => {
					this.$store.commit(
						"setTimer",
						this.$store.state.mainTimer - 1
					);
					if (this.$store.state.mainTimer < 1) {
						this.$router.push({ path: "/" });
						this.$store.commit("setTimer", 60);
					}
				}, 1000);
			}
		},
		mounted() {
			Keyboard.setAccessoryBarVisible({
				isVisible: true
			});
			clearInterval(this.compteur);
			this.addTime();
		}
	};
</script>

<style lang="less">
	*,
	html {
		box-sizing: border-box;
		outline: none;
	}
	body {
		margin: 0;
		padding: 50px;
		height: 100vh;
		overflow: hidden;
		font-family: "HelveticaNeue-Light", "Helvetica Neue Light",
			"Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
		font-weight: 300;
		background: white;
		-webkit-font-smoothing: antialiased;
		#app {
			width: 100%;
			min-height: 100%;
			height: auto;
			display: block;
			overflow-x: hidden;
			overflow-y: auto;
			background: #c9aa6c;
			a.button {
				padding: 8px 30px;
				background: black;
				color: white;
				font-size: 30px;
				font-weight: bold;
				text-transform: uppercase;
				border-radius: 5px;
				text-decoration: none;
				margin: 20px 0;
				&.medium {
					font-size: 18px;
					color: #c9aa6c;
					border-radius: 10px;
				}
				&.back {
					font-size: 30px;
					color: #c9aa6c;
					border-radius: 0px;
					width: 50px;
					height: 50px;
				}
			}
			.page {
				min-height: 100%;
				height: auto;
				header {
					padding: 30px;
					height: 124px;
					display: flex;
					align-items: flex-end;
					justify-content: space-between;
					h3 {
						color: white;
						font-weight: bold;
						font-size: 24px;
						line-height: 32px;
						margin: 0;
						text-align: right;
					}
					h1 {
						margin: 0;
						font-size: 32px;
						text-transform: uppercase;
						line-height: 32px;
						font-weight: bold;
						position: relative;
						&:after {
							content: "";
							position: absolute;
							bottom: 0;
							left: 0;
							width: 52px;
							height: 8px;
							background: white;
							transform: translateY(30px);
						}
					}
					h3 {
					}
				}
				article {
					height: calc(~"100% - 124px");
					display: flex;
					justify-content: center;
					align-items: flex-start;
					text-align: center;
					padding: 60px 30px 70px;
					h2 {
						text-transform: uppercase;
						font-weight: bold;
						color: black;
						line-height: 30px;
						margin: 0 0 20px 0;
					}
					.option {
						width: 260px;
						height: 260px;
						transition: all 0.2s ease-out;
						border: solid 5px white;
						border-radius: 17px;
						display: flex;
						align-items: center;
						justify-content: center;
						flex-direction: column;
						position: relative;
						img {
							max-width: 90%;
							height: auto;
						}
						&.selected {
							background: white;
							> img {
								filter: invert(100%);
							}
						}
						.exemple {
							position: absolute;
							top: 100%;
							padding: 0 20px;
							font-weight: bold;
							text-transform: uppercase;
							font-size: 16px;
							line-height: 17px;
							transform: translateY(-29px);
							display: flex;
							flex-direction: column;
							align-items: center;
							img {
								margin-bottom: 10px;
							}
						}
					}
					.gauche {
						display: flex;
						align-items: center;
						justify-content: center;
						flex-direction: column;
						flex: 1;
					}
					.droite {
						display: flex;
						align-items: center;
						justify-content: center;
						flex-direction: column;
						flex: 1;
					}
				}
				footer {
					position: fixed;
					z-index: 99;
					bottom: 50px;
					left: 50px;
					right: 50px;
					height: 50px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.button {
						height: 50px;
						border-radius: 0;
						padding: 0 25px;
						line-height: 50px;
						&.medium {
							i {
								padding-left: 10px;
								font-size: 24px;
								vertical-align: middle;
							}
						}
						&.back {
							padding: 0;
							text-align: center;
						}
					}
				}
			}
			#timing {
				position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				font-weight: bold;
				color: black;
				z-index: 9999;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 11px;
				height: 50px;
				background-color: white;
				a {
					color: #c9aa6c;
					padding-left: 10px;
				}
			}
		}
	}
</style>
